/**
 * @generated SignedSource<<906dd14251fdb6f342203a83244d97d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpBidModalContext_viewer$data = {
  readonly user?: {
    readonly socialNetworkByName: {
      readonly userPreferences?: {
        readonly zipCode: string | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useLatestUserInfo_viewer">;
  readonly " $fragmentType": "NftPdpBidModalContext_viewer";
};
export type NftPdpBidModalContext_viewer$key = {
  readonly " $data"?: NftPdpBidModalContext_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContext_viewer">;
};

import NftPdpBidModalContextQuery_graphql from './NftPdpBidModalContextQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": NftPdpBidModalContextQuery_graphql
    }
  },
  "name": "NftPdpBidModalContext_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useLatestUserInfo_viewer"
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "socialNetworkName",
                  "value": "ETHEREUM"
                }
              ],
              "concreteType": null,
              "kind": "LinkedField",
              "name": "socialNetworkByName",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "EthereumSocialConnectionUserPreferencesType",
                      "kind": "LinkedField",
                      "name": "userPreferences",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "zipCode",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "EthereumSocialConnection",
                  "abstractKey": null
                }
              ],
              "storageKey": "socialNetworkByName(socialNetworkName:\"ETHEREUM\")"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "63a2df73a7aa4df537483e007f18372a";

export default node;
